import React, { Component } from "react";
import { connect } from "react-redux";
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';

import Api from "Apps/Signally/Api";
import { magicLinkLogin, displayError, saveOnboardingUserData, clearSignatureData, displayLoading } from "Apps/Signally/Actions";

import { Button } from "@knxlab/components";

class LoginScreen extends Component {

	static defaultProps = {
		onLogged: () => {}
	}

	constructor(props) {
		super(props);
		this.state = {
			email: (this.props.onboardingData && this.props.onboardingData.profile && this.props.onboardingData.profile.email) || 'david@knx-lab.com',
			code: '',
			domain: '',
			step: 1,
			loading: false
		}
	}

	checkEmailAndSendCode = async () => {
		const { email, domain } = this.state;

		this.setState({ loading: true });

		try {

			const sendCodeMethod = this.props.sendCodeMethod || Api.magicLinkSend;

			const result = await sendCodeMethod({ email, domain });
			this.setState({
				code: result.code + ""
			})
			if (!result.success) {
				throw new Error("Error unknown");
			}

			this.setState({
				step: 2
			})
		} catch (e) {
			this.props.displayError({ error_msg: e.message, error: e });
		}

		this.setState({ loading: false });
	}

	signin = async () => {

		this.setState({ loading: true });
		try {

			this.props.displayLoading();
			const signinMethod = this.props.signinMethod || this.props.magicLinkLogin;
			const authData = await signinMethod({
				email: this.state.email,
				code: this.state.code,
			});

			/// SAVE DATA
			if (authData.payload.action === 'register') {
				await this.props.saveOnboardingUserData();
			}

			this.props.onLogged();

		} catch (e) {
			console.error(e);
			this.props.displayError({ error_msg: "Signin error", error: e });
			this.setState({ loading: false });
		}

		this.props.displayLoading({ display: false });

	}

	renderStep1() {
		return (
			<div>
				<h1 style={{textAlign: 'center', fontWeight: '400'}}>Connect to Signally using only your email address</h1>
				<Paper style={{padding: '3em',  paddingTop: '1em', display: 'flex', flexDirection: 'column', alignItems: 'center'}} elevation={1}>
					<h1 style={{textAlign: 'center', fontWeight: '300'}}>Connect to signally</h1>
					<TextField
						id="email"
						label="Email"
						onChange={({ target: { value: email } }) => this.setState({ email })}
						value={this.state.email}
						type="email"
						name="email"
						autoComplete="email"
						margin="normal"
						variant="outlined"
						style={{width: '500px'}}
	        		/>
					<Button
						variant="contained"
						key="sendCode"
						disabled={this.state.loading}
						loading={this.state.loading}
						onClick={this.checkEmailAndSendCode}
						color="primary"
					>Send me a magic link</Button>
				</Paper>
			</div>
		)
	}

	renderStep2() {
		return (
			<Paper style={{padding: '3em', paddingTop: '1em', display: 'flex', flexDirection: 'column'}} elevation={1}>

				<h1
					style={{textAlign: 'center', fontWeight: '400'}}
				>Check your email !</h1>
				<p>
					We've emailed a special link to <span style={{fontWeight: 'bold'}}>{this.state.email}</span><br/>
					Enter the code received by email to connect
				</p>
				<p>
					{/*eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
					You got nothing ? <a href='#' onClick={this.checkEmailAndSendCode}>Resend Email</a>
				</p>
				<div style={{width: '100%', textAlign: 'center'}}>
					<TextField
						label="Code"
						onChange={({ target: { value: code } }) => this.setState({ code })}
						value={this.state.code}
						margin="normal"
						variant="outlined"
					/>
					<br/>
					<Button
						key="login"
						disabled={this.state.loading}
						loading={this.state.loading}
						onClick={this.signin}
					>Login</Button>
				</div>
			</Paper>
		)
	}

	render() {
		if (this.state.step === 1) return this.renderStep1();
		if (this.state.step === 2) return this.renderStep2();
	}

}


export default connect(
	state => ({
		onboardingData: state.onboarding.signatureData
	}),
	{ magicLinkLogin, displayError, saveOnboardingUserData, clearSignatureData, displayLoading }
)(LoginScreen);